import React, { Component } from 'react';
import { Grid, GridCell } from 'rmwc/Grid';
import { connect } from 'react-redux';
import { Typography } from 'rmwc/Typography';
import { Card } from 'rmwc/Card';

class UserNoFlowChartPage extends Component{
	constructor(props) {
    	super(props)
    	this.state = {
    		data:{
    			roadmapName: ''
    		}
    	}
    }
    render () {
    	return (
    		<Grid>
                <GridCell span="12">
                    <Card style={{padding: '25px'}}>
                        <Typography use="headline5"> {this.props.roadmapName} </Typography>
                    </Card>
                </GridCell>
                <GridCell span="12">
                    <Card style={{padding: '25px'}}>
                        <Typography use="subtitle2"> Currently, there is no roadmap in such a name!</Typography>
                    </Card>
                </GridCell>
            </Grid>
    	)
    }
}

function mapStateToProps({user, admin}) {
  return {
    user,
    admin
  }
}

function mapDispatchToProps() {
  return {}
}

export default connect(mapStateToProps, mapDispatchToProps)(UserNoFlowChartPage);


// WEBPACK FOOTER //
// ./src/views/roadmap/UserNoFlowChartPage.jsx